import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'add-manager-page';

export const addManagerPage: managerTypes.AddManagerPage = (data) => {
  return axios.post(`/manager/page`, data);
};

type UseAddManagerPageOptions = {
  config?: MutationConfig<typeof addManagerPage>;
};

export function useAddManagerPage({ config = {} }: UseAddManagerPageOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Adding page...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers']);
      managerMutationToasts.success(TOAST_ID, 'Page added successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: addManagerPage,
  });
}
